/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Muhoza 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Cyabararika": ["Buhuye", "Bwuzuri", "Gasanze", "Gatare", "Gatorwa", "Kabogobogo", "Yorodani"],
  "Kigombe": ["Kavumu", "Kiryi", "Mugara", "Nduruma", "Nyamagumba", "Nyamuremure", "Rukereza"],
  "Mpenge": ["Gikwege", "Giramahoro", "Mpenge", "Rukoro", "Rusagara"],
  "Ruhengeri": ["Buhoro", "Burera", "Bushozi", "Byimana", "Kabaya", "Muhe", "Susa"]
};